export default function extractDialogProps(props)
{
  const {
    open,
    onClose,
    handleClose,
    TransitionProps,
    ...rest
  } = props;

  return [
    { open, onClose: onClose ?? handleClose, TransitionProps },
    rest
  ]
}